function init () {
  const containers = document.querySelectorAll('.b-instagram__feed')

  if (!containers.length) {
    return
  }

  getFeed()
    .then(response => response.json())
    .then(feed => processFeed(feed.data, containers))
}

function getFeed () {
  return fetch('/wp-content/themes/billion-dollar-boy/src/php/api/instagram.php', {
    credentials: 'same-origin'
  })
}

function processFeed (data, containers) {
  // console.log(data)
  const posts = data.map(post => {
    if (post.type === 'video') {
      return templateVideo(post)
    } else {
      return templateImage(post)
    }
  })
  displayFeed(posts, containers)
}

function displayFeed (posts, containers) {
  const fragment = document.createDocumentFragment()

  posts.forEach(post => {
    const li = document.createElement('li')
    li.innerHTML = post
    fragment.appendChild(li)
  })

  containers.forEach(container => {
    container.parentNode.classList.remove('is-loading')
    container.appendChild(fragment)
  })
}

function templateImage (post) {
  return `
    <a href="${post.link}" target="_blank">
      <img
        src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
        data-src="${post.images.standard_resolution.url}"
        alt="${post.caption.text}"
        class="lazyload"
      >
      <div class="b-instagram__overlay">
        <p><strong>${post.likes.count}</strong> likes. <strong>${post.comments.count}</strong> comments.</p>
      </div>
    </a>
  `
}

function templateVideo (post) {
  return `
    <a href="${post.link}" target="_blank">
      <video
        loop
        autoplay
        muted
        webkit-playsinline
        playsinline
      >
        <source src="${post.videos.standard_resolution.url}" type="video/mp4">
      </video>
      <div class="b-instagram__overlay">
        <p><strong>${post.likes.count}</strong> likes. <strong>${post.comments.count}</strong> comments.</p>
      </div>
    </a>
  `
}

export default init
